<template>
  <v-list-item v-if="!isEditing" class="it-hv">
    <abt-item-avatar :icon="'fal fa-heart'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">留学で重要視するもの</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">留学で重要視するもの</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">回答なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getPreferenceLabelItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>留学で重要視するもの</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="回答なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <span class="caption">重要視するものを選択</span>
        <v-chip-group multiple column
          active-class="secondary white--text"
          v-model="form.preferences.content">
          <v-chip
            v-for="item in getPreferenceItems"
            :key="`preferences_content_${item.value}`"
            :value="item.value"
            :rules="rules.preferences">{{ item.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.preferences.note"
          label="重要視の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyPreferences',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      meta: {
        preferences: {
          budget: '予算（安く）',
          curriculum: '学校のカリキュラム',
          facility: '学校設備',
          stay: 'ホームステイなどの滞在先',
          japanese: '日本人率',
          safety: '治安の良さ',
          skillup: '資格/専門課程が学べる',
          urban: '都会',
          countryside: '田舎',
          environment: 'アットホームな環境',
          amusement: '遊べる',
          study: '勉強に集中できる',
          work: '海外での就労',
          other: 'その他'
        }
      },
      form: {
        preferences: {
          id: '',
          content: [],
          note: ''
        }
      },
      rules: {
        preferences: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.preferences
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.preferences.content && this.$props.data.preferences.content === 'NONE'))
        this.$set(this.form, 'preferences', {
          id: '' + (this.$props.data.preferences.id ? this.$props.data.preferences.id : 'new_preferences'),
          content: this.$props.data.preferences.content ? this.$props.data.preferences.content.split(',') : [],
          note: this.$props.data.preferences.note ? this.$props.data.preferences.note : ''
        })
      } else {
        this.$set(this.form, 'preferences', {
          id: 'new_preferences',
          content: [],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'preferences'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.preferences, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['preferences', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'preferences'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['preferences', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'preferences'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.preferences &&
        this.$props.data.preferences.content &&
        this.$props.data.preferences.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.preferences &&
        this.$props.data.preferences.content
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.preferences &&
        this.$props.data.preferences.note
      ) ? this.$props.data.preferences.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.preferences &&
        this.$props.data.preferences.note
      )
    },
    getPreferenceItems () {
      return Object.keys(this.meta.preferences).map(key => {
        return {
          text: this.meta.preferences[key],
          value: key
        }
      })
    },
    getPreferenceLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.preferences &&
        this.$props.data.preferences.content
      ) ? this.$props.data.preferences.content.split(',').map(key => {
          return (this.meta.preferences[key]) ? this.meta.preferences[key] : ''
        }) : []
    }
  }
}
</script>
